
import { defineComponent } from 'vue';
import cusButton from '../customize-button/index.vue';

export default defineComponent({
    components: {
        cusButton
    }
});
